export default function useExternalLinkModal () {

    const isOpen = useState( 'isOpen', () => false );
    const currentLink = useState( 'currentLink', () => null );

    const openModal = ( link ) => {
        isOpen.value = true;
        setCurrentLink( link );
    };

    const closeModal = () => {
        isOpen.value = false;
        setCurrentLink( null );
    };

    const setCurrentLink = ( link ) => {
        currentLink.value = link;
    };

    return {
        isOpen,
        currentLink,
        openModal,
        closeModal,
        setCurrentLink,
    };

} 